/**
 * @generated SignedSource<<2ffcc095fed392f93b96c7edfc81be46>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "SurveyQuestion",
        "kind": "LinkedField",
        "name": "nextQuestion",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationPercentage",
                "storageKey": null
            }
        ],
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SurveyResponseStep_setSurveyResponseAnswerMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetSurveyResponseAnswer",
                    "kind": "LinkedField",
                    "name": "surveyResponder_setSurveyResponseAnswer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SurveyResponse",
                            "kind": "LinkedField",
                            "name": "response",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SurveyResponseStep_setSurveyResponseAnswerMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetSurveyResponseAnswer",
                    "kind": "LinkedField",
                    "name": "surveyResponder_setSurveyResponseAnswer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SurveyResponse",
                            "kind": "LinkedField",
                            "name": "response",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6a18b9a7046cabad234ca7d1435da2ed",
            "id": null,
            "metadata": {},
            "name": "SurveyResponseStep_setSurveyResponseAnswerMutation",
            "operationKind": "mutation",
            "text": "mutation SurveyResponseStep_setSurveyResponseAnswerMutation(\n  $model: SetSurveyResponseAnswerRequestInput!\n) {\n  surveyResponder_setSurveyResponseAnswer(model: $model) {\n    response {\n      status\n      id\n    }\n    nextQuestion {\n      id\n      locationPercentage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "eeda91857502d0a11f489a040988656b";
export default node;
